import BaseApi from './base-api';

interface ParkedCall {
    call_id: string;
    presence_user: string;
    cid_number: string;
    cid_name: string;
    cid_uri: string;
}

export type ParkedCalls = Record<string, ParkedCall>[];

export class CallParkingApi extends BaseApi {
    constructor() {
        super();
        return this;
    }

    public async getParkedCalls(kazooApiUrl: string, kazooAccountId: string, kazooAuthToken: string) {
        const config = {
            cache: 'no-store',
            headers: {
                'X-Auth-Token': kazooAuthToken
            }
        };

        const url = `${kazooApiUrl}/v2/accounts/${kazooAccountId}/parked_calls`;
        const resp = await this.fetchKazooApi(url, config);
        const parkedCalls = resp.data as ParkedCalls;
        return parkedCalls;
    }
}
